import { render, staticRenderFns } from "./FormMetadata.vue?vue&type=template&id=adff8a7a&lang=pug"
import script from "./FormMetadata.vue?vue&type=script&lang=js"
export * from "./FormMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adff8a7a')) {
      api.createRecord('adff8a7a', component.options)
    } else {
      api.reload('adff8a7a', component.options)
    }
    module.hot.accept("./FormMetadata.vue?vue&type=template&id=adff8a7a&lang=pug", function () {
      api.rerender('adff8a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormMetadata.vue"
export default component.exports